import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["instanceId"];
import { HUBSPOT_FORM_WINDOW_KEY } from 'ui-forms-embed-components-frame-container/constants/window';
import { MessageTypes } from 'web-interactives-embed-framework';
const FORMS_GLOBAL_EVENTS = {
  ON_FORM_READY: 'hs-form-event:on-ready',
  ON_FORM_SUBMISSION_SUCCESS: 'hs-form-event:on-submission:success',
  ON_FORM_SUBMISSION_FAILED: 'hs-form-event:on-submission:failed',
  ON_FORM_INTERACTION_NAVIGATE: 'hs-form-event:on-interaction:navigate',
  ON_FORM_INTERACTION_NAVIGATE_NEXT: 'hs-form-event:on-interaction:navigate:next',
  ON_FORM_INTERACTION_NAVIGATE_PREVIOUS: 'hs-form-event:on-interaction:navigate:previous'
};
export class FormCommunicatorController {
  constructor({
    applicationController
  }) {
    this.setExtraSubmissionMetadata = ({
      instanceId,
      metadata
    }) => {
      const form = this.getForm(instanceId);
      if (form) {
        form.setExtraSubmissionMetadata(metadata);
      }
    };
    this.setFieldValue = ({
      instanceId,
      propertyReference,
      value
    }) => {
      const form = this.getForm(instanceId);
      if (form) {
        form.setFieldValue(propertyReference, value);
      }
    };
    this.handleFormReady = () => {
      this.applicationController.fireContainerReady();
    };
    this.handleFormSubmit = ({
      redirectUrl
    }) => {
      if (redirectUrl) {
        this.applicationController.navigatePage(redirectUrl);
      }
    };
    this.applicationController = applicationController;
  }
  initialiseFormCommunicators(parentCommunicators) {
    this.listenForEmbedContext();
    this.initializeFormGlobalEventListeners(parentCommunicators);
  }
  initializeFormGlobalEventListeners(parentCommunicators) {
    this.listenForFormReady(parentCommunicators);
    this.listenForFormSubmissionSuccess(parentCommunicators);
    this.listenForFormSubmissionFailed(parentCommunicators);
    this.listenForFormNavigation(parentCommunicators);
    this.listenForFormNavigationNext(parentCommunicators);
    this.listenForFormNavigationPrevious(parentCommunicators);
  }
  listenForEmbedContext() {
    this.applicationController.registerHandler(MessageTypes.SEND_EMBED_CONTEXT, _ref => {
      let {
          instanceId
        } = _ref,
        props = _objectWithoutPropertiesLoose(_ref, _excluded);
      this.setExtraSubmissionMetadata({
        instanceId,
        metadata: props
      });
    });
  }
  listenForFormReady({
    sendFormReadyEvent
  }) {
    document.addEventListener(FORMS_GLOBAL_EVENTS.ON_FORM_READY, ({
      detail
    }) => {
      this.handleFormReady();
      sendFormReadyEvent(detail);
    });
  }
  listenForFormSubmissionSuccess({
    sendFormSubmissionSuccessInfo,
    sendFormSubmissionSuccessEvent
  }) {
    document.addEventListener(FORMS_GLOBAL_EVENTS.ON_FORM_SUBMISSION_SUCCESS, event => {
      const redirectUrl = window[HUBSPOT_FORM_WINDOW_KEY].getFormFromEvent(event).getRedirectUrl();
      sendFormSubmissionSuccessInfo(event.detail.instanceId);
      sendFormSubmissionSuccessEvent(event.detail);
      this.handleFormSubmit({
        redirectUrl
      });
      if (redirectUrl) {
        window.addEventListener('pageshow', _event => {
          if (_event.persisted) window.location.reload();
        });
      }
    });
  }
  listenForFormSubmissionFailed({
    sendFormSubmissionFailedEvent
  }) {
    document.addEventListener(FORMS_GLOBAL_EVENTS.ON_FORM_SUBMISSION_FAILED, ({
      detail
    }) => {
      sendFormSubmissionFailedEvent(detail);
    });
  }
  listenForFormNavigation({
    sendFormNavigationEvent
  }) {
    document.addEventListener(FORMS_GLOBAL_EVENTS.ON_FORM_INTERACTION_NAVIGATE, ({
      detail
    }) => {
      sendFormNavigationEvent(detail);
    });
  }
  listenForFormNavigationNext({
    sendFormNavigationNextEvent
  }) {
    document.addEventListener(FORMS_GLOBAL_EVENTS.ON_FORM_INTERACTION_NAVIGATE_NEXT, ({
      detail
    }) => {
      sendFormNavigationNextEvent(detail);
    });
  }
  listenForFormNavigationPrevious({
    sendFormNavigationPreviousEvent
  }) {
    document.addEventListener(FORMS_GLOBAL_EVENTS.ON_FORM_INTERACTION_NAVIGATE_PREVIOUS, ({
      detail
    }) => {
      sendFormNavigationPreviousEvent(detail);
    });
  }
  getForm(instanceId) {
    const _window = window;
    if (!_window[HUBSPOT_FORM_WINDOW_KEY]) return;
    return _window[HUBSPOT_FORM_WINDOW_KEY].getForms().find(_form => _form.getInstanceId() === instanceId);
  }
}
export const createFormCommunicatorController = ({
  applicationController
}) => new FormCommunicatorController({
  applicationController
});